// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportOptInHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentCreditReportOptInHandler_optIn } from '@zg-rentals/ts-rent-payment-client';

import type { RentCreditReportOptInWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface RentCreditReportOptInHandler_optIn_Args {
  postData: RentCreditReportOptInWebApiRequestDto;
}

export type RentCreditReportOptInHandler_optIn_Options = UseMutationOptions<
  void,
  unknown,
  RentCreditReportOptInHandler_optIn_Args
>;

/**
 * Opt in to rent reporting
 */
export const useRentCreditReportOptInHandler_optIn = ({
  httpClient,
  ...options
}: Omit<RentCreditReportOptInHandler_optIn_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentCreditReportOptInHandler_optIn_Args) =>
      RentCreditReportOptInHandler_optIn(args.postData, httpClient),
  });
};
